module.exports = __webpack_public_path__ + "img/164.125f5f2f.png";